import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CreateTaskAiIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path
      d="M7.5 2.25C8.93775 2.25 10.2679 2.70209 11.3682 3.46484L10.3887 4.44336C9.55176 3.91027 8.55958 3.59961 7.5 3.59961C4.52325 3.59961 2.09961 6.02325 2.09961 9C2.09961 11.9767 4.52325 14.4004 7.5 14.4004C8.2897 14.4004 9.0389 14.2245 9.71387 13.9141L10.7266 14.9268C9.76808 15.4532 8.66773 15.75 7.5 15.75C3.774 15.75 0.75 12.726 0.75 9C0.75 5.274 3.774 2.25 7.5 2.25ZM12.7021 11.2979L14.25 12L12.7021 12.7021L12 14.25L11.2979 12.7021L9.75 12L11.2979 11.2979L12 9.75L12.7021 11.2979ZM14.25 4.39648L6.54785 12.1055L3.68652 9.24316L4.6377 8.29102L6.54785 10.2012L13.2979 3.45117L14.25 4.39648ZM15.4424 7.80762L17.25 8.625L15.4424 9.44238L14.625 11.25L13.8076 9.44238L12 8.625L13.8076 7.80762L14.625 6L15.4424 7.80762Z"
      fill="url(#paint0_linear_7195_46071)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7195_46071"
        x1="0.75"
        y1="9"
        x2="17.25"
        y2="9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E065FF" />
        <stop offset="1" stopColor="#9747FF" />
      </linearGradient>
    </defs>
  </Icon>
);

export default memo(CreateTaskAiIcon);
